const defaultLanguage = 'uk'

const setLanguage = (language: string): void => {
  localStorage.setItem('language', language)
}

export default function getStorageLanguage() {
  const languageStorage = localStorage.getItem('language')
  try {
    if (languageStorage) {
      return JSON.parse(languageStorage)
    }
    setLanguage(defaultLanguage)
    return defaultLanguage
  } catch (err) {
    setLanguage(defaultLanguage)
    return defaultLanguage
  }
}
